import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@narvar/nth-spinner';

const Loader = ({ margin }) => (
  <div
    style={{
      display: 'table',
      width: '100%',
      height: '100%',
      margin,
    }}
  >
    <div
      style={{
        display: 'table-cell',
        verticalAlign: 'middle',
        textAlign: 'center',
      }}
    >
      <Spinner />
    </div>
  </div>
);

Loader.defaultProps = {
  margin: undefined,
};

Loader.propTypes = {
  margin: PropTypes.string,
};

export default Loader;
